import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import { getNoticeList, copyNotice, deleteNotice } from '@/services/product/notice';
import { getSellerList } from '@/services/customer/erpCustomerList';
export default {
  name: 'noticeList',
  i18n: require('./i18n-notice'),
  data: function data() {
    return {
      dataList: [],
      // 到货通知列表数据
      isTableLoading: false,
      // 表格加载中

      columns: [{
        title: this.$t('arrivalNotice.noticeTitle'),
        //通知名称
        dataIndex: 'noticeTitle',
        key: 'noticeTitle',
        width: '25%',
        ellipsis: true
      }, {
        title: this.$t('arrivalNotice.sellerName'),
        // 担当者
        dataIndex: 'sellerName',
        key: 'sellerName',
        width: '15%',
        ellipsis: true
      }, {
        title: this.$t('arrivalNotice.productNum'),
        // 商品数量
        dataIndex: 'productNum',
        key: 'productNum',
        width: '15%',
        align: 'right'
      }, {
        title: this.$t('arrivalNotice.customerNum'),
        // 得意先数量
        dataIndex: 'erpcustomerNum',
        key: 'erpcustomerNum',
        width: '15%',
        align: 'right',
        ellipsis: true
      }, {
        title: this.$t('arrivalNotice.updateTime'),
        // 更新时间
        dataIndex: 'lastUpdateTime',
        key: 'lastUpdateTime',
        width: '15%',
        ellipsis: true
      }, {
        title: this.$t('arrivalNotice.action'),
        // 操作
        dataIndex: 'action',
        key: 'action',
        // width: '15%',

        ellipsis: true,
        scopedSlots: {
          customRender: 'action'
        }
      }],
      // 表格列
      listTotal: 0,
      //搜索条件
      queryParam: {
        page: 1,
        size: 10,
        sellerCode: undefined,
        //担当者
        noticeTitle: undefined // 通知名称
      },
      sellerOptions: [] // 担当者options
    };
  },
  computed: {},
  watch: {},
  mounted: function mounted() {
    this.getList();
    this.getSellerListData();
    console.log('this', this);
  },
  methods: {
    /**
     * 处理删除
     */
    handleDelete: function handleDelete(record) {
      var _this = this;
      deleteNotice(record.noticeid).then(function (res) {
        if (res.data.code == 200) {
          _this.getList();
          _this.$message.success(_this.$t('public.deleteSuccessfully'));
        }
      });
    },
    /**
     * 处理复制
     */
    handleCopy: function handleCopy(record) {
      var _this2 = this;
      copyNotice(record.noticeid).then(function (res) {
        if (res.data.code == 200) {
          _this2.getList();
          _this2.$message.success(_this2.$t('public.copySuccessfully'));
        }
      });
    },
    /**
    * 处理编辑
     *
     */
    handleEdit: function handleEdit(record) {
      this.$router.push({
        path: '/productNotice/edit',
        query: {
          noticeid: record.noticeid
        }
      });
    },
    /**
     * 处理新建
     *
     */
    handleAdd: function handleAdd() {
      this.$router.push({
        path: '/productNotice/add'
      });
    },
    /**
     * 获取担当者列表
     *
     * */
    getSellerListData: function getSellerListData() {
      var _this3 = this;
      getSellerList({
        type: 1
      }).then(function (res) {
        if (res.data.code === 200) {
          _this3.sellerOptions = res.data.data;
        }
      });
    },
    /* 获取列表功能 */getList: function getList() {
      var _this4 = this;
      this.isTableLoading = true;
      var params = {
        page: this.queryParam.page,
        size: this.queryParam.size,
        noticeTitle: this.queryParam.noticeTitle,
        sellerCode: this.queryParam.sellerCode
      };
      getNoticeList(params).then(function (response) {
        if (response.data.code == 200) {
          if (_.isObject(response.data.data)) {
            _this4.dataList = response.data.data.list || [];
            _this4.listTotal = response.data.data.total || 0;
          }
        }
      }).finally(function () {
        _this4.isTableLoading = false;
      });
    },
    /**
     * 页码改变
     *
     * */
    tableChange: function tableChange(pagination, filters, sorter, _ref) {
      var currentDataSource = _ref.currentDataSource;
      this.queryParam.page = pagination.current;
      this.queryParam.size = pagination.pageSize;
      this.getList();
    }
  }
};